import { Box, Stack } from '@chakra-ui/react';
import Providers from '@components/crm/lead/Providers';
import { useUserDetails } from '@components/crm/shared/queries';
import Spinner from '@components/icons/Spinner';
import Button from '@components/interactive/Button';
import WizardLayout from '@components/layout/layout/WizardLayout';
import Body1 from '@components/typography/Body1';
import Header from '@components/typography/Header';
import { Routes } from '@constants/routes';
import { useAuthenticatedContextProvider } from '@contexts/AuthenticatedContextProvider';
import { PlanType } from '@enums/PlanType';
import getPrimaryPlan from '@utils/getPrimaryPlan';
import { useEffect } from 'react';
import AepBreadCrumbs from '../AepBreadCrumbs';
import { useMutation } from '@tanstack/react-query';
import { updateVericredProviders } from '@lib/requests';

const AepProviders = () => {
  // Resources
  const { authenticatedUser: user, handleLogout } = useAuthenticatedContextProvider();
  const plan = getPrimaryPlan(user);
  const isMAPlan = plan?.plan_type === PlanType.MA;
  const { data: userDetails, error } = useUserDetails({ userId: user?.id });

  const updateVericredProvidersMutation = useMutation({
    mutationFn: updateVericredProviders,
  });

  useEffect(() => {
    if (!error) return;

    handleLogout(user);
  }, [error]);

  useEffect(() => {
    if (
      user &&
      !updateVericredProvidersMutation.isLoading &&
      !updateVericredProvidersMutation.isSuccess &&
      !updateVericredProvidersMutation.isError
    ) {
      updateVericredProvidersMutation.mutate({ userId: user.id });
    }
  }, [user]);

  const isLoading = updateVericredProvidersMutation.isLoading;
  const userProviders = userDetails?.providers.filter((provider) => !provider.connecture_id_not_found_at) || [];

  return (
    <WizardLayout>
      <AepBreadCrumbs />
      {isLoading ? (
        <Box p={10}>
          <Spinner />
        </Box>
      ) : userDetails ? (
        <>
          <Header as="h3">
            {userProviders.length ? 'Confirm Doctors That You See Regularly' : 'Add Doctors That You See Regularly'}
          </Header>
          <Body1>Insurance coverage varies by doctor's office. Make sure each doctor's address is correct.</Body1>
          <Stack width="100%" maxW="600px">
            <Providers userId={user.id} clientFacing />
          </Stack>
          <Button id="aep-providers-next" href={isMAPlan ? Routes.aepRecommendations : Routes.aepPrescriptions} mt={3}>
            Next
          </Button>
        </>
      ) : (
        <Box p={10}>
          <Spinner />
        </Box>
      )}
    </WizardLayout>
  );
};

export default AepProviders;
